<template>
  <div v-if="items.length" class="position-relative">
    <CarouselWidget
      class="slide-show-section"
      :items="items"
      :itemsToShow="{
        xs: 1,
        sm: 1,
        md: 1,
        lg: 1,
        xl: 1,
      }"
      :gap="0"
      nav
      nav-inside
    >
      <template #item="{ item }">
        <v-card v-bind="getLinkAttrs(item.link, server)" flat tile>
          <img
            :src="
              files +
              (xsOnly && item.mobile
                ? item.mobile + '?resize=1&w=600'
                : item.desktop + '?resize=1&w=1920')
            "
            class="slide-show-section_img d-block"
            width="100%"
          />
        </v-card>
      </template>
    </CarouselWidget>

    <div class="d-flex align-center informations">
      <v-container class="d-flex justify-center justify-md-end py-0">
        <v-sheet
          class="py-8 px-md-6 mb-md-12 informations-square"
          :color="smAndDown ? 'transparent' : 'primary'"
          width="360px"
        >
          <div
            class="
              white--text
              text-subtitle-1 text-md-h6 text-center
              font-weight-medium
            "
          >
            Receba nossa proposta de matrícula:
          </div>
          <RegistrySlideForm
            class="mt-6"
            :action="server + formAction"
            :responseText="responseText"
          />
        </v-sheet>
      </v-container>
    </div>
  </div>
</template>

<script>
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";
import RegistrySlideForm from "../forms/RegistrySlideForm.vue";
import { getLinkAttrs } from "../../utils/getLinkAttrs";

const _config = {
  mod: "slides",
};

const _data = {
  formAction: "/rest/email/registry",
  responseText: "Agradecemos o contato, responderemos o mais breve possível.",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.filter(({ desktop }) => !!desktop);
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getLinkAttrs,
  },
  beforeCreate() {
    this.$rest(_config.mod).get();
  },
  components: {
    CarouselWidget,
    RegistrySlideForm,
  },
};
</script>

<style lang="scss" scoped>
.slide-show-section {
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.25);

  &_img {
    aspect-ratio: 1920 / 680;
    height: 100%;
    object-fit: cover;
    -o-object-fit: cover;
    width: 100%;

    @media screen and (min-width: 960px) {
      min-height: 540px;
    }

    @media screen and (max-width: 600px) {
      aspect-ratio: 600 / 600;
    }
  }
}

.informations {
  @media screen and (max-width: 959.9px) {
    background-color: var(--v-primary-base);
  }

  @media screen and (min-width: 960px) {
    bottom: 0;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;

    &-square {
      border-radius: 20px;
      pointer-events: initial;
    }
  }
}
</style>
